import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "./UsersService";

const initialState = {
    user: [],
    users: null,
    search: null,
    allUsers: null,
    usersByBusiness: null,
    singleUser: null,
    isError: false,
    isSuccess: false,
    isLodaing: false,
    editSuccess: false,
    massage: "",
    check: "",
};

export const getAllUsers = createAsyncThunk(
    "user/get",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.getAllUsers(data, token);
        } catch (error) {
            const massage =
                (error.response &&
                    error.response.data &&
                    error.response.data.massage) ||
                error.response.data.error ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const getUserByBusiness = createAsyncThunk(
    "/users/business",
    async (business_id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.getUserByBusiness(business_id, token);
        } catch (error) {
            const message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getAllUsersWihtoutPage = createAsyncThunk(
    "user/getAll",
    async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.getAllUsersWihtoutPage(token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const UsersSearch = createAsyncThunk(
    "user/search",
    async (searchValue, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.UsersSearch(searchValue, token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const CreateNewUser = createAsyncThunk(
    "user/create",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.createUser(token, data);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const CreateUserDocuments = createAsyncThunk(
    "user/create/document",
    async (data, thunkAPI) => {
        try {
            let token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.CreateUserDocuments(data, token);
        } catch (error) {
            let message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const ShowUserDocuments = createAsyncThunk(
    "user/create/document",
    async (user_id, thunkAPI) => {
        try {
            let token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.ShowUserDocuments(user_id, token);
        } catch (error) {
            let message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getSingleUsers = createAsyncThunk(
    "user/getSingle",
    async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.getSingleUsers(token, id);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const updateUser = createAsyncThunk(
    "user/update",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.updateUser(token, data);
        } catch (error) {
            const massage =
                (error.response &&
                    error.response.data &&
                    error.response.data.massage) ||
                error.response.data.error ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const deleteUser = createAsyncThunk(
    "user/update",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.deleteUser(data, token);
        } catch (error) {
            const massage =
                (error.response &&
                    error.response.data &&
                    error.response.data.massage) ||
                error.response.data.error ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const CheckUserAuthorized = createAsyncThunk(
    "user/check",
    async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await userService.CheckUserAuthorized(token);
        } catch (error) {
            const massage = error
                // (error.response &&
                //     error.response.data &&
                //     error.response.data.massage) ||
                // error.response.data.error ||
                // error.message ||
                // error.toString();
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const usersSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        reset: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isLodaing = false;
            state.isDeleteLodaing = false;
            state.editSuccess = false;
            state.massage = "";
        },
        userSearchAction: (state, action) => {
            state.search = action.payload;
        },
    },
    extraReducers: {
        //getAllUsers Actions
        [getAllUsers.pending]: (state) => {
            state.isLodaing = true;
        },
        [getAllUsers.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.users = action.payload;
            state.isSuccess = true;
        },
        [getAllUsers.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //getUserByBusiness Actions
        [getUserByBusiness.pending]: (state) => {
            state.isLodaing = true;
        },
        [getUserByBusiness.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.usersByBusiness = action.payload;
            state.isSuccess = true;
        },
        [getUserByBusiness.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //UsersSearch Actions
        [UsersSearch.pending]: (state) => {
            state.isLodaing = true;
        },
        [UsersSearch.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.users = action.payload;
            state.isSuccess = true;
        },
        [UsersSearch.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //getAllUsersWithoutPage Actions
        [getAllUsersWihtoutPage.pending]: (state) => {
            state.isLodaing = true;
        },
        [getAllUsersWihtoutPage.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.allUsers = action.payload;
            state.isSuccess = true;
        },
        [getAllUsersWihtoutPage.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //ShowUserDocuments Actions
        [ShowUserDocuments.pending]: (state) => {
            state.isLodaing = true;
        },
        [ShowUserDocuments.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.user_documents = action.payload;
            state.isSuccess = true;
        },
        [ShowUserDocuments.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },
        //CreateNewUser Actions
        [CreateNewUser.pending]: (state) => {
            state.isLodaing = true;
        },
        [CreateNewUser.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.user = action.payload;
            state.users.data.data.push(action.payload.data);
            state.isSuccess = true;
        },
        [CreateNewUser.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //getSingleUsers Actions
        [getSingleUsers.pending]: (state) => {
            state.isLodaing = true;
        },
        [getSingleUsers.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.singleUser = action.payload;
            state.isSuccess = true;
        },
        [getSingleUsers.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //update  user actions  Actions
        [updateUser.pending]: (state) => {
            state.isLodaing = true;
        },
        [updateUser.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.editSuccess = true;
        },
        [updateUser.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },
        [CheckUserAuthorized.rejected] : (state ,action) => {
            state.check = action.payload
        },
    },
});

export const { reset, userSearchAction } = usersSlice.actions;
export default usersSlice.reducer;
